export const collection_name = {
  v2_clients: "v2_clients",
  v2_jobs: "v2_jobs",
  v2_company: "v2_company",
  v2_recruiters: "v2_recruiters",
};
